const ns = {};

/**
 * Der BlockLoader laedt einzelne Bloecke via AJAX nach und fuegt diese in das
 * Dokument ein. Anschliessend wird die Callback-Funktion aufgerufen, sofern
 * diese gesetzt wurde.
 *
 */
ns.BlockLoader = function() {
    this.response = null;
    this.map = {};
    this.doProcessAssets = false;
    this.assetKeys = {
        scripts: '__scripts',
        styles: '__styles'
    };
    this.scriptsContainer = $('head');
    this.stylesContainer = this.scriptsContainer;
};

/**
 * Ermoeglicht das Setzten einer Callback-Funktion, welche nach verarbeiteter
 * Response aufgerufen wird.
 *
 * @param {Function} callback Die Callback-Funktion
 */
ns.BlockLoader.prototype.setCallback = function(callback) {

    this.callback = callback;
    return this;
};

/**
 * Bestimmt, ob Assets in der Response (scripts, styles) verarbeitet werden
 * sollen.
 *
 * @param {Bool} doProcess
 */
ns.BlockLoader.prototype.setAssetProcessing = function(doProcess) {

	this.doProcessAssets = !!doProcess;
    return this;
};

/**
 * Setzt den Container, in welchem nach zu ersetzenden und einfuegenden Scripts
 * zu suchen ist (sofern asset processing aktiv ist).
 */
ns.BlockLoader.prototype.setScriptsContainer = function(container) {

    this.scriptsContainer = container;
    return this;
};

/**
 * Setzt den Container, in welchem nach zu ersetzenden und einfuegenden Styles
 * zu suchen ist (sofern asset processing aktiv ist).
 */
ns.BlockLoader.prototype.setStylesContainer = function(container) {

    this.stylesContainer = container;
    return this;
};

/**
 * Bestimmt die Zuordnungen der von der Response erwarteten Blocke zu aktuell
 * im HTML vorhandenen Bloecken. Letztere werden dabei mit dem HTML der Response
 * gefuellt.
 *
 * @param {Object} map
 */
ns.BlockLoader.prototype.mapBlocks = function(map) {

	$.extend(this.map, map);
    return this;
};


ns.BlockLoader.prototype.request = function(url, params, method, loadingOverlay) {

    var self = this;

    if ('undefined' === typeof method) {
        method = 'GET';
    } else {
        method = method.toUpperCase();
    }

    if ('undefined' === typeof loadingOverlay) {
        loadingOverlay = false;
    }

    $.ajax({
        url: url,
        data: params,
        type: method,
        loadingOverlay: loadingOverlay
    }).done(function(data) {
        self.response = data;
        if (typeof data === 'object' && typeof data.redirect != 'undefined') {
            $("[unsavedInput=true]").removeAttr('unsavedInput');
            window.location.href = window.location.origin + '/' + data.redirect;
        }
        try {
            self.process(data, self);
                self.callback && self.callback(true);
        } catch (e) {
            console.error('Blockloader error!');
            console.error(e);
            console.error('Response-Data:', data);
            console.error(this);
            var errMsg = '<p>' + data.toString() + '</p>';

            $(document).trigger('blockLoadError', errMsg);
            self.callback && self.callback(false);
        }

        window.Esearcher?.vue3initializer?.reinitialize();

    }).fail(function (e) {
        $(document).trigger('blockLoadError', e.responseText);
        self.callback && self.callback(false);
    });

    $(document).trigger('loadStart');
};

/**
 * Verarbeitet die empfangenen Bloecke.
 *
 * @param {jQuery} data
 */
ns.BlockLoader.prototype.process = function(data) {

    var self = this;

    let promises = [];
    if (typeof(data) === 'object') {
        promises = $.map(data, function (obj, key) {

            if (self.map.hasOwnProperty(key)) {
                self.map[key].html(data[key]);
            } else if ((key === self.assetKeys.scripts ||
                key === self.assetKeys.styles) && self.processAssets) {
                return self.processAssets($(obj), data);
            }
        });
    }

    Promise.all(promises).then(() => {
        $(document).trigger('loadFinish', data);
    });
};

ns.BlockLoader.prototype.processAssets = function(assets, data) {

    if (assets.first().prop('tagName') === 'LINK') {
        this.replaceLinkTags(assets);
    } else if (assets.first().prop('tagName') === 'SCRIPT') {
        return this.addScriptTags(assets);
    }
};

/**
 * Ersetzt die link-Tags durch die neuen, bereits vorhandene werden nicht
 * angefasst.
 *
 * @param {jQuery} newLinks
 */
ns.BlockLoader.prototype.replaceLinkTags = function(newLinks) {

    var self = this;

    newLinks.each(function(idx, el) {

        var href = $(el).attr('href') + "?" + $("body").data("es3-version-hash");

        if (self.stylesContainer.find('link[href="' + href + '"]').length === 0) {
            self.stylesContainer.append('<link href="' + href + '" rel="stylesheet" type="text/css" />');
        }
    });

};

/**
 * Fuegt das neue script-Tag asynchron über einen Promise ein, und wartet auf das 'load' event zum resolven.
 *
 * @param {string} src
 */
 ns.BlockLoader.prototype.loadScript = function(src) {
    return new Promise(resolve => {
        var script = document.createElement("script");
        script.type = "text/javascript";

        script.onload = resolve;

        script.src = src;

        // bei einem append auf 'self.scriptsContainer' funktioniert das onload Event nicht!
        document.head.appendChild(script);
    });
}

/**
 * Fuegt die neuen script-Tags ein, bereits vorhandene werden nicht
 * angefasst.
 *
 * @param {jQuery} newScripts
 */
ns.BlockLoader.prototype.addScriptTags = function(newScripts) {
    var self = this;
    var scripts = [];

    newScripts.each(function(idx, el) {
        if (el.tagName !== 'SCRIPT') {
            return;
        }
        var src = $(el).attr('src') + "?" + $("body").data("es3-version-hash");
        if (self.scriptsContainer.find('script[src="' + src + '"]').length === 0) {
            scripts.push(src);
        }
    });

    return Promise.all(scripts.map((src) => { return self.loadScript(src); }));
};

export default ns.BlockLoader;
